/* eslint-disable no-secrets/no-secrets */
/* eslint-disable no-underscore-dangle */
/* eslint-disable one-var */
/* eslint-disable no-return-assign */
/* eslint-disable func-names */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-arrow-callback */
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import { getConfigValue } from "@jutro/config";
import appConfig from 'app-config';
import { loadGtag, subscribe, JUTRO_TOPICS, DefaultWhitelistProvider as WhitelistProvider, DefaultDictionaryProvider as DictionaryProvider } from "@jutro/events";


/**
 * Created based on platform\@jutro\events\defaultimplementation\ga.js
 * This is needed because the OOTB event category names need to 
 * be changed to match the current Production event category names
 * US26437-PE-Analytics
 */
function initDefaultGAEnt() {

    const ga4TrackingId = getConfigValue("GA4_TRACKING_ID") || appConfig.GA4_TRACKING_ID;

    const gtag = loadGtag(ga4TrackingId);

    gtag('config', ga4TrackingId, {
      'cookie_flags': 'SameSite=None;Secure',
      'cookie_domain': 'none',
      // 'debug_mode': true   // uncomment for debugging
    });   
 
    subscribe(JUTRO_TOPICS.UNKNOWN_ERROR, (event) => {
      return gtag("event", "exception", {
        "description": event.error
      });
    });

    subscribe([JUTRO_TOPICS.ROUTE_CHANGED], (event) => {
      gtag("event", "page_view", {
        "page_location": event.pathname
      });
    });
    
    subscribe(
      [
        JUTRO_TOPICS.FETCH_REQUEST,
        // JUTRO_TOPICS.FETCH_RESPONSE,
        JUTRO_TOPICS.FETCH_ERROR
      ],
      (event, topic) => {
        gtag("event", "custom", {
          "topic": topic,
          "serviceEndPoint": event.serviceEndPoint,
          "method": event.method
        });
      }
    );


  /*
    Uncomment if you want to track individual input values
    MAY CAUSE PII ISSUES

    const trackingConfig =
        arguments.length > 0 && void 0 !== arguments[0]
          ? arguments[0]
          : { whitelistConfig: {}, dictionaryConfig: {} };    

    subscribe([JUTRO_TOPICS.VALUE_CHANGED, JUTRO_TOPICS.FIELD_BLUR], function(
      event,
      topic
    ) {
      let _trackingConfig$dicti, _trackingConfig$dicti2;

      return gtag("event", "custom", {
        "topic": topic,
        event_category:
          null === (_trackingConfig$dicti = trackingConfig.dictionaryConfig) ||
          void 0 === _trackingConfig$dicti ||
          null === (_trackingConfig$dicti2 = _trackingConfig$dicti.eventKeys) ||
          void 0 === _trackingConfig$dicti2
            ? void 0
            : _trackingConfig$dicti2.path,
        event_label: event.path
      });
    });
    */

    /*
    Uncomment if you want to track button clicks

    subscribe(
      [JUTRO_TOPICS.BUTTON_CLICKED, JUTRO_TOPICS.LINK_CLICKED],
      function(event, topic) {
        return gtag("event", "custom", {
          "topic": topic,
          event_category: event.label,
          event_label: _JSON$stringify(event)
        });
      }
    ); 
    */

    /*
    Uncomment if you want track when React Components are loaded

    subscribe(JUTRO_TOPICS.COMPONENT_LOADED, function(event, topic) {    
      gtag("event", "custom", {
        "topic": topic,
        "componentName": event.componentName
      });
    });
    */
}

export default initDefaultGAEnt;